import { useEffect, useRef } from 'react';

import { bridgeAtom, isOpenChatAtom, useAtom, useValue, widgetPopupsStatesAtom } from '@/store';

import { PopupState, tooltipConfig, WidgetPopupType } from '@/modules/models';

const DEFAULT_DELAY = 5000;

interface UseInitPopupWithCloseBtnProps {
  isDisabled: boolean;
  isWidgetHidden: boolean;
  startPopupWithDelay: (popupType: WidgetPopupType, delay: number) => void;
}

export const useInitPopupWithCloseBtn = ({ isWidgetHidden, startPopupWithDelay }: UseInitPopupWithCloseBtnProps) => {
  const isOpenChat = useValue(isOpenChatAtom);
  const { widget } = useValue(bridgeAtom);
  const { initTooltip } = widget || {};
  const [widgetPopupsStates, setWidgetPopupsStates] = useAtom(widgetPopupsStatesAtom);
  const { INIT_WITH_CLOSE_BTN } = widgetPopupsStates;
  const startedRef = useRef(false);

  useEffect(() => {
    if (
      isOpenChat ||
      isWidgetHidden ||
      !initTooltip ||
      (INIT_WITH_CLOSE_BTN !== PopupState.IDLE && INIT_WITH_CLOSE_BTN !== PopupState.VISIBLE) ||
      startedRef.current
    ) {
      return;
    }

    setWidgetPopupsStates((prevState) => ({
      ...prevState,
      [WidgetPopupType.INIT_WITH_CLOSE_BTN]: PopupState.STARTED,
    }));
  }, [isOpenChat, isWidgetHidden, initTooltip, INIT_WITH_CLOSE_BTN, setWidgetPopupsStates]);

  useEffect(() => {
    if (INIT_WITH_CLOSE_BTN !== PopupState.STARTED || startedRef.current) {
      return;
    }
    startedRef.current = true;

    const delay = (initTooltip as tooltipConfig)?.delay ?? DEFAULT_DELAY;
    startPopupWithDelay(WidgetPopupType.INIT_WITH_CLOSE_BTN, delay);
  }, [initTooltip, INIT_WITH_CLOSE_BTN, setWidgetPopupsStates, startPopupWithDelay]);

  return null;
};
